import artifact from '$houdini/artifacts/LIB_createInventory'
import { MutationStore } from '../runtime/stores/mutation'

export class LIB_createInventoryStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
